(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('vtLink', {
        templateUrl: 'views/components/views/vtLink/vtLink.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'utilityService', 'vtLinkService', 'p2ReportDefService', 'ttGridFactory', function ($stateParams, stateService, utilityService, vtLinkService, p2ReportDefService, ttGridFactory) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let vtKeyno = $stateParams.vt_keyno;
            let vtLinkKeyno = $stateParams.vtlink_keyno;

            vm.model = {
                gridVtLinkMultiReady: false,
                setting: {},
                selectListLinkTypes: [],
                selectListWebPages: []
            };

            vm.gridVtLinkMulti = new ttGridFactory({
                rememberId: 'w_vtlink_multi_grid',
                kendo: {
                    height: '100%',
                    sortable: true,
                    aggregate: true,
                    pager: false,
                    selectable: false,
                    filterable: false
                }
            });
            
            // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadSetting() {
                vm.model.setting = (await vtLinkService.getSetting({
                    vt_keyno: vtKeyno,
                    vtlink_keyno: vtLinkKeyno,
                }))[0];

                return loadGridVtLinkMulti();
            }

            async function loadLinkTypes() {
                vm.model.selectListLinkTypes = await vtLinkService.listLinkTypes();
            }

            async function loadWebPages() {
                vm.model.selectListWebPages = await p2ReportDefService.listWebPages();
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region GRID PROCEDURE FUNCTION CALLS

            async function loadGridVtLinkMulti() {
                vm.gridVtLinkMulti.dataTask.loadData = {
                    method: 3795,
                    parameters: vm.model.setting
                };

                vm.model.gridVtLinkMultiReady = true;

                if (vm.gridVtLinkMulti.gridfunc !== null) vm.gridVtLinkMulti.gridfunc.read();
            }

            // #endregion GRID PROCEDURE FUNCTION CALLS

            // #region FIELD CHANGE MULTI FUNCTIONS

            vm.onChanged = function (value, id) {
                switch (id) {
                    case 'argtype':
                        if (utilityService.validateWatchValue(value, vm.model.setting.argtype) !== true) return;
                        
                        vm.model.setting.argtype = value;

                        if (utilityService.validateParmsValue(vm.model.setting.argtype) !== true) return;
                        
                        loadGridVtLinkMulti();
                        break;
                    default:
                        utilityService.setValueToVariable(value);
                        break;
                }
            };

            // #endregion FIELD CHANGE MULTI FUNCTIONS

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
            	loadSetting();
                loadLinkTypes();
                loadWebPages();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
